export default "__VITE_ASSET__DfAeDCEc__"